
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/manage-subscription",
      function () {
        return require("private-next-pages/manage-subscription/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/manage-subscription"])
      });
    }
  